import { useContext, useSyncExternalStore } from "react";
import { FeatureFlagsContext, FeatureFlagsReadyContext } from "./context";
import { FEATURE_FLAGS } from "./feature-flags.constant";
import { getSnapshot, subscribe } from "./snapshot";

export const useFeatureFlag = (
  name: (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS],
): boolean => {
  const context = useContext(FeatureFlagsContext);
  // Outside the provider (anything opened through DialogRoot) read the global
  // snapshot the provider publishes, instead of silently reporting every flag
  // off.
  const global = useSyncExternalStore(subscribe, getSnapshot);
  return (context ?? global)[name]?.on ?? false;
};

/** Whether a flag reading off can be trusted (see FeatureFlagsReadyContext). */
export const useFeatureFlagsReady = (): boolean =>
  useContext(FeatureFlagsReadyContext);
